import { ComponentFactory, ComponentFactoryResolver, ComponentRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core'
import { LoadingComponent } from './loading.component'

export enum EppStatus {
  Normal, Loading, Empty
}

@Directive({
  selector: '[eppStatus]'
})
export class StatusDirective {

  loadingFactory : ComponentFactory<LoadingComponent>
  loadingComponent : ComponentRef<LoadingComponent>

  @Input()
  set eppStatus(status: EppStatus) {
    switch (status) {
      case EppStatus.Empty:
        this.vc.clear()
        this.loadingComponent = this.vc.createComponent(this.loadingFactory)
        break
      case EppStatus.Loading:
        this.vc.clear()
        this.loadingComponent = this.vc.createComponent(this.loadingFactory)
        break
      case EppStatus.Normal:
        this.vc.clear()
        this.vc.createEmbeddedView(this.templateRef)
        break
    }
  }

  constructor (
    private templateRef: TemplateRef<any>,
    private vc: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {
    // Create resolver for loading component
    this.loadingFactory = this.componentFactoryResolver.resolveComponentFactory(LoadingComponent)
  }
}